import React from 'react';
import PropTypes from 'prop-types';

import { FileIcon } from '../FileUpload';

const TextSnippetFile = ({ mediaType, name, additionalFiles }) => (
  <div className="flex">
    <FileIcon mime={mediaType} size="6" className="text-green-500 shrink-0" />
    <div className="ml-2 align-top text-slate-900 text-sm truncate overflow-hidden">{name}</div>
    {additionalFiles && (
      <div className="ml-6 align-top text-slate-900 text-sm shrink-0">{additionalFiles}</div>
    )}
  </div>
);

TextSnippetFile.defaultProps = {
  additionalFiles: undefined,
};

TextSnippetFile.propTypes = {
  mediaType: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  additionalFiles: PropTypes.string,
};

export default TextSnippetFile;
